import UserContext from "Components/UserContext/UserContext";

const UserConsumer = UserContext.Consumer;

export default UserConsumer;